import { render } from "./EmployeeAnnouncement.vue?vue&type=template&id=091fef1c"
import script from "./EmployeeAnnouncement.vue?vue&type=script&lang=js"
export * from "./EmployeeAnnouncement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__